import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDOPuC-C_kNYDsya137Si76lJ-yxtTg2mg',
  authDomain: 'abstracto-recovered.firebaseapp.com',
  projectId: 'abstracto-recovered',
  storageBucket: 'abstracto-recovered.firebasestorage.app',
  messagingSenderId: '604211807123',
  appId: '1:604211807123:web:e1ff59bf53020e23361e66',
  measurementId: 'G-NYGTLJPFX6'
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const storage = firebase.storage();
export const auth = firebase.auth();
export const serverTimestamp = () => firebase.firestore.FieldValue.serverTimestamp();

export const authenticatedFetch = async (url, options = {}) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Authentication required');
  const token = await user.getIdToken();
  return fetch(url, {
    ...options,
    headers: {
      'content-type': 'application/json',
      ...options.headers,
      authorization: `Bearer ${token}`
    }
  });
};
